import produce from 'immer';

const INITIAL_STATE = {
  token: null,
  loading: false,
  profile: null,
  logged: false,
};

export default function doctor(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@doctor/SIGN_IN_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@doctor/SIGN_IN_SUCCESS': {
        draft.token = action.payload.token;
        draft.profile = action.payload.doctor;
        draft.loading = false;
        draft.logged = true;
        break;
      }
      case '@doctor/SIGN_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@doctor/SIGN_OUT': {
        draft.token = null;
        draft.profile = null;
        draft.logged = false;
        break;
      }
      default:
    }
  });
}
